var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B99FC",
    d: "M9.83 5.879c7.826-7.766 20.514-7.766 28.34 0l.942.934c.391.389.391 1.018 0 1.406l-3.222 3.197c-.196.195-.513.195-.708 0l-1.296-1.286c-5.46-5.417-14.312-5.417-19.77 0l-1.389 1.378c-.196.194-.513.194-.708 0L8.797 8.31c-.392-.389-.392-1.018 0-1.407L9.83 5.88zm35.003 6.612l2.868 2.845c.391.388.391 1.018 0 1.406l-12.93 12.83c-.391.389-1.026.389-1.417 0l-9.177-9.105c-.097-.098-.256-.098-.354 0l-9.176 9.106c-.392.388-1.026.388-1.417 0L.3 16.742c-.391-.388-.391-1.018 0-1.406l2.867-2.845c.392-.389 1.026-.389 1.417 0l9.177 9.106c.098.097.257.097.354 0l9.177-9.107c.39-.388 1.025-.388 1.417 0l9.176 9.107c.098.097.257.097.355 0l9.176-9.106c.392-.389 1.026-.389 1.417 0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.3fa7ca57.svg";
export { ForwardRef as ReactComponent };